import { DTOReportesShipments } from "../../DTO/Reportes/DTOReportesShipments";
import { DTOReporteShipmentsFilters } from "../../DTO/Reportes/Filters/DTOReportesShipmentsFilters";
import http from "../common/http-common"
class ReportesService{
    getReporteShipments(filters: DTOReporteShipmentsFilters){
        return http.get<DTOReportesShipments[]>("/Reportes/Shipments", { params: filters });
    }
}

export default new ReportesService();